/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled/macro';

export const ButtonLink = styled.a`
    width: 100%;
`;

export const Wrapper = styled.div`
    width: 100%;
    margin-top: 8px;
`;
